export default __webpack_public_path__ + "static/5-travelling-to-northern-territory-7516fd7ef6a352fc9bd8a6b0f94b2dfe.jpg";